import { html } from 'lit';
import InteractiveButton from '@effectivastudio/lit-components/components/interactive_button/element.js';

/**
 * Interactive like button
 *
 * @prop card_id - id of the item that should be liked/disliked
 * @prop count - number of likes
 * @prop active - currently liked?
 *
 */
export class CardLike extends InteractiveButton {
  static properties = {
    card_id: { type: Number },
    textOn: { type: Boolean },
  };

  constructor() {
    super();
    this.as = 'like';
    this.method = 'patch';
    this.translation = 'card.like';
    this.count = 0;
    this.active = false;
    this.innerClass = 'item-with-icon';
    this.textOn = true;
  }

  shouldPreventAction() {
    return false;
  }

  onClick(e) {
    e.preventDefault();
    this.shouldPreventAction() || super.onClick(e);
  }

  get href() {
    return `/cards/${this.card_id}/toggle_like`;
  }

  get icon() {
    return this.active ? 'heart:solid' : 'heart';
  }

  // 1 Likes
  get translatedText() {
    if (this.count > 0) {
      return html`
        ${this.count} ${this.textOn ? this.renderTranslatedText() : null}
      `;
    } else {
      return null;
    }
  }

  renderTranslatedText() {
    const text = super.translatedText.replace(/\s*\d+\s*/, '');

    return html`<span>${text}</span>`;
  }

  renderIcon() {
    return html`<bu-icon name=${this.icon}></bu-icon>`;
  }

  displaySnackBarError() {} // no-op
}

export default CardLike;

customElements.get('bu-card-like') ||
  customElements.define('bu-card-like', CardLike);
